import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-6 footer-col">
            <h4>About TGH</h4>
            <ul>
              <li>
                <Link to="/about-us/overview">Overview</Link>
              </li>
              <li>
                <Link to="/about-us/history">History & Background</Link>
              </li>
              <li>
                <Link to="/about-us/governance">Governance Structure</Link>
              </li>
              <li>
                <Link to="/about-us/senior-management">Senior Management</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>
          </div>
          <div className="col-lg-3 col-md-6 footer-col">
            <h4>Patient Care</h4>
            <ul>
              <li>
                <Link to="/general-care">General Care Services</Link>
              </li>
              <li>
                <Link to="/specialized">Specialized Services</Link>
              </li>
              <li>
                <Link to="/diagnostic">Diagnostic Services</Link>
              </li>
              <li>
                <Link to="/corporate">Billing & Insurance</Link>
              </li>
              <li>
                <Link to="/contact">Contact us</Link>
              </li>
            </ul>
          </div>
          <div className="col-lg-3 col-md-6 footer-col">
            <h4>Resources</h4>
            <ul>
              <li>
                <Link to="/news">News & Media</Link>
              </li>
              <li>
                <Link to="/faq">FAQs</Link>
              </li>
              <li>
                <Link to="/gallery">Gallery</Link>
              </li>
              <li>
                <a href="https://www.moh.gov.gh/" target="_blank" rel="noopener noreferrer">
                  Ministry of Health
                </a>
              </li>
              <li>
                <a href="https://www.nhis.gov.gh/" target="_blank" rel="noopener noreferrer">
                  National Health Insurance
                </a>
              </li>
            </ul>
          </div>
          <div className="col-lg-3 col-md-6 footer-col">
            <h4>Contact Information</h4>
            <ul>
              <li>
                <i className="bi bi-geo-alt"></i>
                <span>P.O. Box 14, Tema Community 12, Tema, Ghana</span>
              </li>
              <li>
                <i className="bi bi-telephone-fill"></i>
                <a href="tel:+233303302696">+233 30-330-2696/7</a>
              </li>
              <li>
                <i className="bi bi-envelope"></i>
                <a href="mailto:temageneral.ghgar@ghs.gov.gh">temageneral.ghgar@ghs.gov.gh</a>
              </li>
              <li>
                <i className="bi bi-clock"></i>
                <span>24/7 Emergency Services</span>
              </li>
            </ul>
            <div className="mt-3">
              <a className="btn btn-sm-square btn-light me-2" href="https://www.facebook.com/share/1ZpbAkrnP8/" aria-label="Facebook">
                <i className="bi bi-facebook"></i>
              </a>
              <a className="btn btn-sm-square btn-light me-2" href="#" aria-label="X">
                <span style={{ fontWeight: 700, fontSize: '0.95rem', lineHeight: 1 }}>X</span>
              </a>
              <a className="btn btn-sm-square btn-light me-2" href="https://www.tiktok.com/@temageneralhospit?_r=1&_t=ZS-95kUwJ95qiL" aria-label="TikTok">
                <i className="bi bi-tiktok"></i>
              </a>
              <a className="btn btn-sm-square btn-light" href="#" aria-label="YouTube">
                <i className="bi bi-youtube"></i>
              </a>
            </div>
          </div>
        </div>
        <hr className="my-4" style={{ borderColor: '#444' }} />
        <div className="row">
          <div className="col-12 text-center">
            <p className="mb-0">
              &copy; {new Date().getFullYear()} Tema General Hospital. All rights reserved.
            </p>
            <p className="mt-2 mb-0">
              <a href="tel:+233556700674" className="footer-dev-credit">
                Developed by City Square Tech
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
